import { Component, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AccountSettingsService } from '@core';
import { isNewDocumentLayoutEnabled } from '@shared/models/account-settings';

@Component({
  selector: 'app-preview-features',
  templateUrl: './preview-features.component.html',
  styleUrls: ['./preview-features.component.scss']
})
export class PreviewFeaturesComponent implements OnInit {

  loading = false;
  salesOrderV2_5NewLayout = true;
  salesOrderV2_5MultiPayment = false;
  newDocumentLayout = false;

  constructor(private accountSettingsService: AccountSettingsService) { }

  async ngOnInit() {
    this.loading = true;
    try {
      const settings = await this.accountSettingsService.loadAccountSettings();
      this.salesOrderV2_5NewLayout = settings?.salesOrderV2_5NewLayout ?? true;
      this.salesOrderV2_5MultiPayment = !!settings?.salesOrderV2_5MultiPayment;
      this.newDocumentLayout = isNewDocumentLayoutEnabled(settings);
    } finally {
      this.loading = false;
    }
  }

  async onSalesOrderV2_5NewLayoutChanged(event: MatSlideToggleChange) {
    const newValue = event.checked;
    this.salesOrderV2_5NewLayout = newValue;
    if (newValue === false) this.salesOrderV2_5MultiPayment = false;
    await this.accountSettingsService.saveAccountSettings({
      salesOrderV2_5NewLayout: newValue,
      ...(newValue ? {} : { salesOrderV2_5MultiPayment: false }),
    });
  }

  async onSalesOrderV2_5MultiPaymentChanged(event: MatSlideToggleChange) {
    const newValue = event.checked;
    this.salesOrderV2_5MultiPayment = newValue;
    await this.accountSettingsService.saveAccountSettings({ salesOrderV2_5MultiPayment: newValue });
  }

  async onNewDocumentLayoutChanged(event: MatSlideToggleChange) {
    this.newDocumentLayout = event.checked;
    await this.accountSettingsService.saveAccountSettings({ newDocumentLayout: event.checked });
  }
}
